import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const Container = styled(FlexColumn)`
    max-width: 1365px;
    width: 100%;
    gap: 12px;
`;
export const CarouselWrapper = styled.div`
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    background: ${carbon[0]};
    box-shadow: 0 3px 6px 0 ${rgba(carbon[500], 0.08)};
    position: relative;
    border-radius: 6px;

    .carouselItemWrapper {
        width: 100%;
    }

    button {
        z-index: 10;
    }
`;
